import { type ToolCallMessagePartComponent } from '@assistant-ui/react';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';
import { MeetingRoomCard, PlaceCard, ResortPlaceCard, TicketmasterCard } from './card';
import './RecommendationsTool.scss';
import { type Recommendation, RecommendationType } from './types';

interface Result {
  readonly recommendations: readonly Recommendation[];
}

export const RecommendationsToolName = 'recommendations';

export const RecommendationsTool: ToolCallMessagePartComponent<unknown, Result> = ({ result }) => {
  const numSlides = result?.recommendations.length ?? 0;
  return (
    <div className={'recommendations-tool'}>
      <Swiper
        spaceBetween={10}
        modules={[Navigation, Pagination]}
        navigation={true}
        pagination={{
          clickable: true,
        }}
        breakpoints={{
          768: {
            slidesPerView: Math.min(numSlides, 2),
          },
          1216: {
            slidesPerView: Math.min(numSlides, 3),
          },
        }}
      >
        {result?.recommendations.map((r, idx) => {
          return (
            <SwiperSlide key={idx}>
              {r.recommendation_type === RecommendationType.Ticketmaster ? (
                <TicketmasterCard ticketmaster={r} />
              ) : r.recommendation_type === RecommendationType.Leisure ? (
                <PlaceCard recommendation={r} />
              ) : r.recommendation_type === RecommendationType.MeetingRoom ? (
                <MeetingRoomCard meetingRoom={r} />
              ) : (
                <ResortPlaceCard resortPlace={r} />
              )}
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};
